
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import { DashboardTasksData } from "@/utils/dashboard/dashboard-tasks-data";
import { getModel, Model } from "@/utils/models/model";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppHumanFilterListEdit from "@/components/models/HumanFilterListEdit.vue";

export default Vue.extend({
	data(){
		return {
			data: new DashboardTasksData(),
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		},
		title: {
			type: [String, Object as ()=>TranslateResult],
			required: true
		},
	},
	computed: {
		model():Model | undefined{
			return getModel("Task");
		}
	},
	watch: {
		item: {
			immediate: true,
			handler(){
				if (!this.item.Data) {
					this.data = new DashboardTasksData();
					return;
				}
				this.data = new DashboardTasksData(this.item.Data.getJSON());
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.item.Data = this.data;
			this.$emit("confirm", this.item);
			this.close();
		},
	},
	components: {
		AppHumanFilterListEdit
	}
});
